<template>
  <va-card :title="$t('tables.administrators')">
    <template slot="actions">
      <va-button icon="fa fa-refresh" color="info" @click="refresh()" :disabled="loading == true"/>
      <va-button icon="fa fa-gear" color="info" :disabled="loading == true" />
      <va-button icon="fa fa-plus" color="info" :disabled="loading == true" @click="add()"/>
    </template>
    <div class="row">
      <div class="flex xs12">
        <div class="row">
          <div class="flex xs12">
            <va-data-table
              :fields="fields"
              :data="admins"
              :per-page="15"
              clickable
              :loading="loading"
              hoverable
            >
              <template slot="icon">
                <va-icon name="fa fa-user-md" color="secondary" />
              </template>
              <template slot="status" slot-scope="props">
                <va-badge
                  :color="getBadgeColor(props.rowData.inactive)"
                >{{ getBadgeText(props.rowData.inactive) }}</va-badge>
              </template>
              <template slot="actions" slot-scope="props">
                <va-button
                  flat
                  small
                  :disabled="props.rowData.role.super_admin == true"
                  color="info"
                  icon="iconicstroke iconicstroke-mail"
                  @click="sendInvitation(props.rowData)"
                />
                <va-button
                  flat
                  small
                  color="info"
                  icon="fa fa-pencil"
                  :disabled="props.rowData.role.super_admin == true"
                  @click="editItem(props.rowData)"
                />
                <va-button
                  flat
                  small
                  color="danger"
                  icon="fa fa-trash"
                  :disabled="props.rowData.role.super_admin == true"
                  @click="deleteItem(props.rowData)"
                />
              </template>
            </va-data-table>
          </div>
        </div>
      </div>
    </div>
    <div class="modals">
      <div class="flex xs12">
        <va-modal
          size="large"
          max-width="100%"
          v-model="editDialog"
          :title=" $t('modal.editTitle') "
          cancelClass="none"
          :okText=" $t('modal.confirm') "
          :message="message"
          noOutsideDismiss
          noEscDismiss
          @cancel="close"
          @ok="save"
        >
          <div class="form-elements">
            <form>
              <div class="row">
                <div class="flex xs12">
                  <va-input
                    v-model="editedItem.name"
                    placeholder="Administrator Name"
                    label="Administrator Name"
                  ></va-input>
                </div>
              </div>
              <div class="row">
                <div class="flex xs12">
                  <va-input
                    v-model="editedItem.family"
                    placeholder="Administrator Family Name"
                    label="Administrator Family Name"
                  ></va-input>
                </div>
              </div>
              <div class="row">
                <div class="flex xs12">
                  <va-input
                    v-model="editedItem.email_address"
                    type="email"
                    label="Email Address"
                    placeholder="Email Address"
                    success
                  ></va-input>
                </div>
              </div>
              <div class="row">
                <div class="flex xs12">
                  <va-checkbox v-model="editedItem.inactive" label="Inactive"></va-checkbox>
                </div>
              </div>
            </form>
          </div>
        </va-modal>
      </div>
    </div>
  </va-card>
</template>

<script>
import adminService from '../../../api/adminService'
import dataFactory from '../../../api/dataFactoryService'

export default {
  data () {
    return {
      loading: false,
      editDialog: false,
      message: '',
      deleteDialog: false,
      admins: [],
      editedIndex: -1,
      editedItem: {
        id: '',
        name: '',
        family: '',
        invitation_sent: false,
        external_id: '',
        emai_verified: false,
        full_name: '',
        email_addres: '',
        inactive: false,
        role: {
          employee: false,
          manager: false,
          super_admin: false,
          admin: true,
        },
      },
      defaultItem: {
        id: '',
        name: '',
        family: '',
        invitation_sent: false,
        external_id: '',
        emai_verified: false,
        full_name: '',
        email_addres: '',
        inactive: false,
        role: {
          employee: false,
          manager: false,
          super_admin: false,
          admin: true,
        },
      },
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:icon',
          width: '30px',
          dataClass: 'text-center',
        },
        {
          name: 'name',
          title: this.$t('tables.administrationHeadings.name'),
          sortField: 'name',
          width: '20%',
        },
        {
          name: 'family',
          title: this.$t('tables.administrationHeadings.family'),
          sortField: 'family',
          width: '20%',
        },
        {
          name: '__slot:status',
          title: this.$t('tables.administrationHeadings.inactive'),
          width: '10%',
        },
        {
          name: 'email_address',
          title: this.$t('tables.administrationHeadings.email'),
          sortField: 'email_address',
          width: '20%',
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
        },
      ]
    },
  },

  watch: {
    editDialog (val) {
      // val || this.close()
      if (!val) {
        console.log('close called')
      }
    },
  },

  async created () {
    await this.initialize()
  },

  methods: {
    getBadgeColor (inactive) {
      if (inactive === true) {
        return 'danger'
      } else {
        return 'info'
      }
    },
    getBadgeText (inactive) {
      if (inactive === true) {
        return 'inactive'
      } else {
        return 'active'
      }
    },
    async refresh () {
      await this.initialize()
      console.log('refresh')
    },
    emailMessage (item) {
      if (item === undefined) {
        return ''
      }
      if (item.invitation_sent) {
        return 'Invitation email resent to ' + item.full_name
      } else {
        return 'Invitation email sent to ' + item.full_name
      }
    },
    async initialize () {
      this.loading = true
      try {
        let adminResult = await adminService.getActive()
        this.admins = dataFactory.createAdminListModel(
          adminResult.payload.data
        )
        // console.log(JSON.stringify(this.admins));
      } catch (error) {
        this.showToast(error, {
          icon: 'fa-exclamation',
          position: 'bottom-right',
          duration: 5000,
        })
      }
      this.loading = false
    },

    async sendInvitation (item) {
      try {
        await adminService.sendInvitation(item.id)
        item.invitation_sent = true
        this.showToast(this.emailMessage(item), {
          icon: 'fa-check',
          position: 'bottom-right',
          duration: 3000,
        })
      } catch (error) {
        this.showToast(error, {
          icon: 'fa-exclamation',
          position: 'bottom-right',
          duration: 5000,
        })
      }
    },

    editItem (item) {
      this.editedIndex = this.admins.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editDialog = true
      this.message = "Edit the selected administrator. Make sure the administrator's email is unique in system."
    },

    async deleteItem (item) {
      const index = this.admins.indexOf(item)
      if (confirm('Are you sure you want to delete this item?')) {
        try {
          await adminService.delete(item.id)
          this.admins.splice(index, 1)
        } catch (error) {
          this.showToast(error, {
            icon: 'fa-exclamation',
            position: 'bottom-right',
            duration: 5000,
          })
        }
      }
    },

    close () {
      this.editDialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
    },

    async save () {
      try {
        this.loading = true
        if (this.editedIndex > -1) {
          await adminService.update(this.editedItem.id, this.editedItem)
          this.admins[this.editedIndex] = Object.assign(this.admins[this.editedIndex], this.editedItem)
        } else {
          var creationResult = await adminService.create(this.editedItem)
          this.editedItem.id = creationResult.payload.data
          this.admins.push(this.editedItem)
        }
        this.editedIndex = -1
        this.editedItem = Object.assign({}, this.defaultItem)
      } catch (error) {
        this.showToast(error, {
          icon: 'fa-exclamation',
          position: 'bottom-right',
          duration: 5000,
        })
      }
      this.editDialog = false
      this.loading = false
    },

    add () {
      this.editDialog = true
      this.message = "Add a new administrator to the system. Make sure the administrator's email is unique in system."
    },
  },
}
</script>

<style lang="scss">
</style>
